import React from 'react';
import { ClockIcon, FileTextIcon, FolderOpenIcon, PuzzleIcon } from 'lucide-react';
import { Accent, SectionHeading } from './SectionHeading';
import { painPoints } from '../../data/content';
const icons = [ClockIcon, FolderOpenIcon, PuzzleIcon, FileTextIcon];
export function PainSection() {
  return <section aria-labelledby="pain-heading" className="bg-brand-oatmeal px-5 py-16 lg:px-8 lg:py-24" data-id="element-135" data-mp="3m1fhptuyjzyp">
      <div className="mx-auto max-w-5xl" data-id="element-136" data-mp="nj9wc6259y0c">
        <SectionHeading id="pain-heading" eyebrow="Sound Familiar?" title={<>
              You Know Hair. <Accent data-id="element-138" data-mp="dsozan24d1jj">But Preparing to Teach It Takes Hours.</Accent>
            </>} data-id="element-137" data-mp="nl345oohuo9x" />

        <ul className="mt-12 grid gap-4 sm:grid-cols-2" role="list" data-id="element-139" data-mp="8unik8s61eb8">
          {painPoints.map((pain, index) => {
          const Icon = icons[index];
          return <li key={pain.title} className="flex items-start gap-4 rounded-[20px] bg-brand-ivory p-6" data-id="element-140" data-mp="11irrd361a7i5" data-mpi={index}>
                <span className="flex h-11 w-11 flex-none items-center justify-center rounded-full bg-white" data-id="element-141" data-mp="3bdhqvox57wz5">
                  <Icon className="h-5 w-5 text-brand-gold" strokeWidth={1.5} aria-hidden="true" data-id="element-142" data-mp="3gcua7zot2lwz" />
                </span>
                <span data-id="element-143" data-mp="31merqsnrxs2i">
                  <span className="block font-display text-[1.35rem] font-bold leading-tight text-brand-charcoal" data-id="element-144" data-mp="31n69azkjdp9s">
                    {pain.title}
                  </span>
                  <span className="mt-1.5 block text-[14px] leading-relaxed text-brand-charcoal/65" data-id="element-145" data-mp="2slovjnulpzo9">{pain.text}</span>
                </span>
              </li>;
        })}
        </ul>

        <p className="mx-auto mt-12 max-w-2xl text-center font-display text-[1.6rem] font-bold leading-snug text-brand-charcoal sm:text-[1.9rem]" data-id="element-146" data-mp="2iplwiqv1qh5j">
          Your expertise should go into teaching your students — <Accent data-id="element-147" data-mp="gy8uqaodkpdp">not rebuilding every class from scratch.</Accent>
        </p>
      </div>
    </section>;
}